import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import fetchNumberCourses from '../../utils/fetchNumberCourses';

export default function HomeRandomCard() {
  const [totalCourses, setTotalCourses] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const counts = await fetchNumberCourses();
        if (!cancelled) setTotalCourses(counts?.totalCourses ?? null);
      } catch {
        if (!cancelled) setTotalCourses(null);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="bg-white py-6 sm:py-10">
      <div className="w-11/12 mx-auto">
        <div className="bg-white rounded-2xl shadow-xl ring-1 ring-slate-200/80 p-6 sm:p-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">
                Random golf course
              </h2>
              <p className="mt-1 text-sm sm:text-base text-slate-600">
                Roll the dice across {totalCourses ? totalCourses.toLocaleString() : 'thousands of'} UK & Ireland courses.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/lists/tools/random-golf-course-generator"
                className="w-full sm:w-auto text-center bg-slate-900 text-white font-semibold rounded-xl py-3 px-6 shadow-md hover:bg-slate-800 transition-colors"
              >
                Open generator
              </Link>
              <Link
                to="/lists/golf-courses/rankings?country=England"
                className="w-full sm:w-auto text-center bg-white text-slate-900 font-semibold rounded-xl py-3 px-6 border border-slate-200 hover:border-slate-400 hover:bg-slate-50 transition-colors"
              >
                Explore rankings
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

